<template>
    <el-button :loading="isLoading" :size="size" :type="type"  @click="clicked" :disabled="disabled" :plain="plain" :icon="icon">{{btnText}}</el-button>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters(["isLoading"]),
  },
  props: {
    btnText:{
      type:String,
      default:'保存'
    },
    type:{
      type:String,
      default:'primary'
    },
    disabled:{
       type:Boolean,
       default:false
    },
    size:{
      type:String,
      default:'medium'
    },
    plain:{
      type:Boolean,
      default:false
    },
    icon:{
      type:String,
      default:''
    }
  },
  methods: {
    clicked(){
      
      this.$emit('click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/btns/loadingBtn.vue